export enum LayoutData_ImagePosition {
  /** CENTER - Image positioned at the center */
  CENTER = "CENTER",
  /** CENTER_LEFT - Image positioned on the left */
  CENTER_LEFT = "CENTER_LEFT",
  /** CENTER_RIGHT - Image positioned on the right */
  CENTER_RIGHT = "CENTER_RIGHT",
  /** TOP - Image positioned at the center top */
  TOP = "TOP",
  /** TOP_LEFT - Image positioned at the top left */
  TOP_LEFT = "TOP_LEFT",
  /** TOP_RIGHT - Image positioned at the top right */
  TOP_RIGHT = "TOP_RIGHT",
  /** BOTTOM - Image positioned at the center bottom */
  BOTTOM = "BOTTOM",
  /** BOTTOM_LEFT - Image positioned at the bottom left */
  BOTTOM_LEFT = "BOTTOM_LEFT",
  /** BOTTOM_RIGHT - Image positioned at the bottom right */
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum LayoutData_ResponsivenessBehaviour {
  /** STACK - Stacking of columns */
  STACK = "STACK",
  /** WRAP - Wrapping of columns */
  WRAP = "WRAP",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum LayoutData_DesignTarget {
  /** LAYOUT - Design applied to layout */
  LAYOUT = "LAYOUT",
  /** CELL - Design applied to cells */
  CELL = "CELL",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum LayoutData_VerticalAlignment_Alignment {
  /** TOP - Top alignment */
  TOP = "TOP",
  /** MIDDLE - Middle alignment */
  MIDDLE = "MIDDLE",
  /** BOTTOM - Bottom alignment */
  BOTTOM = "BOTTOM",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum LayoutData_ImageScaling_Scaling {
  /** AUTO - Auto image scaling */
  AUTO = "AUTO",
  /** CONTAIN - Contain image scaling */
  CONTAIN = "CONTAIN",
  /** COVER - Cover image scaling */
  COVER = "COVER",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum LayoutData_Banner_Origin {
  /** IMAGE - Banner originated from an image */
  IMAGE = "IMAGE",
  /** LAYOUT - Banner originated from a layout */
  LAYOUT = "LAYOUT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/** Background type */
export enum LayoutData_Background_Type {
  /** COLOR - Solid color background */
  COLOR = "COLOR",
  /** GRADIENT - Gradient background */
  GRADIENT = "GRADIENT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/** Backdrop type */
export enum LayoutData_Backdrop_Type {
  /** COLOR - Solid color backdrop */
  COLOR = "COLOR",
  /** GRADIENT - Gradient backdrop */
  GRADIENT = "GRADIENT",
  UNRECOGNIZED = "UNRECOGNIZED",
}